import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import { selectDefTableSize } from '../../../../../../selectors/screenSelectors';
import CheckboxFilter from "../../../../../common/table/Checkbox";
import createSelect from '../../../../../common/table/createSelect';
import NumberInput from '../../../../../common/table/NumberInput';
import StringInput from '../../../../../common/table/StringInput';

class Table extends Component {

    constructor(props){
        super(props);
        this.state = {};
    }

    render(){
        return (
            <div className={`table-main-wrap mt-50 ${!this.props.propsArray.length && this.props.propsGetDataStatus == 'pending' ? 'table-main-wrap_loading' : '' }`}>
                <div className="table-header">Інформація про працівників</div>
                <ReactTable
                    getTheadFilterThProps={(rowInfo) => {
                        return {
                            style: {
                                overflow: 'visible',
                                textAlign: 'left'
                            }
                        }
                    }}
                    getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                            return {
                                onClick: () => {
                                    this.props.propsRowClick({
                                        id: rowInfo.row._original.ID,
                                        index: rowInfo.index
                                    });
                                },
                                style: {
                                    backgroundColor: rowInfo.index === this.props.index ? '#B8B8B8' : 'white',
                                    color: rowInfo.index === this.props.index ? 'white' : 'black',
                                    cursor: 'pointer'
                                }
                            }
                        }else{
                            return {}
                        }
                    }}
                    data={this.props.propsArray}
                    columns={[
                        {
                            Filter: StringInput,
                            id: 'Department/Company/Name',
                            Header: "Назва компанії",
                            accessor: "Department.Company.Name"
                        },
                        {
                            Filter: StringInput,
                            id: 'Department/Name',
                            Header: "Назва відділу",
                            accessor: "Department.Name"
                        },
                        {
                            Filter: StringInput,
                            id: "Surname",
                            Header: "Прізвище",
                            accessor: "Surname"
                        },
                        {
                            Filter: StringInput,
                            Header: "Ім'я",
                            accessor: "Name",
                            id: 'Name'
                        },
                        {
                            Filter: StringInput,
                            Header: "По-батькові",
                            accessor: "Patronymic",
                            id: 'Patronymic'
                        },
                        {
                            Filter: StringInput,
                            Header: "Номер телефону",
                            accessor: "PhoneNumber",
                            id: 'PhoneNumber'
                        },
                        {
                            Filter: StringInput,
                            Header: "Картка",
                            accessor: "Card.Name",
                            id: 'Card/Name'
                        },
                        {
                            Filter: NumberInput,
                            Header: "Кількість ліміту",
                            minWidth: 110,
                            id: "Limit",
                            accessor: item => {
                                return item.Limit == null ? '-------------' : item.Limit
                            }
                        },
                        {
                            Filter: createSelect({ options: this.props.typeTerm, placeholder: 'Виберіть' }),
                            Header: "Термін ліміту",
                            minWidth: 150,
                            id: "TypeTermID",
                            accessor: item => {
                                return item.TypeTerm == null ? '-------------' : item.TypeTerm.TermName
                            }
                        },
                        {
                            Filter: CheckboxFilter,
                            Header: "Заблоковано",
                            minWidth: 150,
                            id: "Closed",
                            accessor: item => {
                                return <input type="checkbox" checked={item.Closed ? true : false} readOnly/>
                            }
                        }
                    ]}
                    className=" -highlight"
                    pageSize={this.props.pageSize}
                    page={this.props.page}
                    onPageSizeChange={this.props.handleChangePageSize}
                    onPageChange={this.props.handleChangePage}
                    manual={true}
                    filterable
                    sortable
                    multiSort
                    onFilteredChange={this.props.handleOnFilterChange}
                    onSortedChange={this.props.handleOnSortChange}
                    filtered={this.props.filtered}
                    sorted={this.props.sorted}
                    pages={Math.ceil(this.props.count / this.props.pageSize)}
                    NoDataComponent={() => null}
                    previousText="Назад"
                    nextText="Вперед"
                    rowsText="рядків"
                    pageText="Сторінка"
                    ofText="з"
                />
                <div className="loading"></div>
            </div>
        )

    }
}

const mapStateToProps = (state) => {
    return {
        defaultPageSize: selectDefTableSize(state),
        typeTerm: typeof state.user.data.typeTermList != "undefined" ? state.user.data.typeTermList: []
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
       dispatch
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Table);
